<template>
  <div class="bacFFF menuBox newsIconColor">
    <div :class="pageShow == 2 ? 'width10' : ''">
      <p class="menuName fwb tar">
        <span
          class="goHome"
          @click="goHome"
          v-if="
            $route.query.gobackType &&
              ($route.query.gobackType == 'ds' ||
                $route.query.gobackType == 'sq')
          "
          >返回首页></span
        >
        <span
          class="goHome"
          @click="goBackPage('ds')"
          v-if="$route.query.gobackType && $route.query.gobackType == 'ds'"
          >返回党史学习专题</span
        >
        <span
          class="goHome"
          @click="goBackPage('sq')"
          v-else-if="$route.query.gobackType && $route.query.gobackType == 'sq'"
          >返回三全育人专题</span
        >
        <span class="goHome" @click="goHome" v-else>返回首页</span>
        <span
          class="goHome"
          @click="jumpView"
          v-if="
            pageShow == 2 &&
              this.$route.query &&
              this.$route.query.from != 'banner'
          "
          >> 返回新闻列表</span
        >
        <template v-if="$route.query.type == 'news_info'">
          <span class="mr12">新闻速览</span>
          <span class="mr12">/</span>
          <span class="excellentCases">News information</span>
        </template>
        <template v-else-if="$route.query.type == 'ad_news'">
          <span class="mr12">安徽大学</span>
          <span class="mr12">/</span>
          <span class="excellentCases">Anhui University</span>
        </template>
        <template v-else-if="$route.query.type == 'work_news'">
          <span class="mr12">通知公告</span>
          <span class="mr12">/</span>
          <span class="excellentCases">Notice notice</span>
        </template>
        <template v-else-if="$route.query.type == 'case_news'">
          <span class="mr12">优秀案例</span>
          <span class="mr12">/</span>
          <span class="excellentCases">Excellent cases</span>
        </template>
        <template v-else-if="$route.query.type == 'chxy_news'">
          <span class="mr12">巢湖学院</span>
          <span class="mr12">/</span>
          <span class="excellentCases">Chaohu University</span>
        </template>
        <template v-else-if="$route.query.type == 'zkd_news'">
          <span class="mr12">中国科学技术大学</span>
          <span class="mr12">/</span>
          <span class="excellentCases"
            >University of Science and Technology of China</span
          >
        </template>
        <template v-else-if="$route.query.type == 'educating'">
          <span class="mr12">三全育人</span>
          <span class="mr12">/</span>
          <span class="excellentCases">Educating</span>
        </template>
        <template v-else-if="$route.query.type == 'courseskey'">
          <span class="mr12">关键课程</span>
          <span class="mr12">/</span>
          <span class="excellentCases">Courseskey</span>
        </template>
        <template v-else-if="$route.query.type == 'ideological'">
          <span class="mr12">网络思政</span>
          <span class="mr12">/</span>
          <span class="excellentCases">Ideological</span>
        </template>
        <template v-else-if="$route.query.type == 'excellent'">
          <span class="mr12">精品课程</span>
          <span class="mr12">/</span>
          <span class="excellentCases">excellent</span>
        </template>
        <template v-else-if="$route.query.type == 'safety'">
          <span class="mr12">课程思政</span>
          <span class="mr12">/</span>
          <span class="excellentCases">Lesson</span>
        </template>
        <template v-else-if="$route.query.type == 'dynamics'">
          <span class="mr12">党建专栏</span>
          <span class="mr12">/</span>
          <span class="excellentCases">Party Building</span>
        </template>
        <template v-else-if="$route.query.type == 'campus'">
          <span class="mr12">文明校园</span>
          <span class="mr12">/</span>
          <span class="excellentCases">Campus</span>
        </template>
        <template v-else-if="$route.query.type == 'campus_culture'">
          <span class="mr12">校园文化</span>
          <span class="mr12">/</span>
          <span class="excellentCases">Campus culture</span>
        </template>
        <template v-else-if="$route.query.type == 'yaowenyaolun'">
          <span class="mr12">要闻要论</span>
          <span class="mr12">/</span>
          <span class="excellentCases">Important News</span>
        </template>
        <template
          v-else-if="
            $route.query.type == 'lilunyanjiu' ||
              $route.query.type == '3qlilunyanjiu'
          "
        >
          <span class="mr12">理论研究</span>
          <span class="mr12">/</span>
          <span class="excellentCases">Theoretical Research</span>
        </template>
        <template v-else-if="$route.query.type == 'xuexiziyuan'">
          <span class="mr12">学习资源</span>
          <span class="mr12">/</span>
          <span class="excellentCases">Learning Resource</span>
        </template>
        <template v-else-if="$route.query.type == 'gongzuodongtai'">
          <span class="mr12">工作动态</span>
          <span class="mr12">/</span>
          <span class="excellentCases">Work News</span>
        </template>
        <template v-else-if="$route.query.type == 'jiaoyujiaoxue'">
          <span class="mr12">教育教学</span>
          <span class="mr12">/</span>
          <span class="excellentCases">Education And Teaching</span>
        </template>
        <template v-else-if="$route.query.type == 'qingshaonianxueds'">
          <span class="mr12">青少年学党史</span>
          <span class="mr12">/</span>
          <span class="excellentCases">Youth Learning Party History</span>
        </template>
        <template v-else-if="$route.query.type == 'wssbss'">
          <span class="mr12">为师生办实事</span>
          <span class="mr12">/</span>
          <span class="excellentCases"
            >Doing practical things for teachers and students</span
          >
        </template>
        <template v-else-if="$route.query.type == 'meitibaodao'">
          <span class="mr12">媒体报道</span>
          <span class="mr12">/</span>
          <span class="excellentCases">Media Coverage</span>
        </template>
        <template v-else-if="$route.query.type == 'xinwendongtai'">
          <span class="mr12">新闻动态</span>
          <span class="mr12">/</span>
          <span class="excellentCases">News Information</span>
        </template>
        <template v-else-if="$route.query.type == 'gongzuobushu'">
          <span class="mr12">工作部署</span>
          <span class="mr12">/</span>
          <span class="excellentCases">Work Deployment</span>
        </template>
        <template v-else-if="$route.query.type == 'dainxingjingyan'">
          <span class="mr12">典型经验</span>
          <span class="mr12">/</span>
          <span class="excellentCases">Typical Experience</span>
        </template>
        <template v-else-if="$route.query.type == 'zhiduwenjain'">
          <span class="mr12">制度文件</span>
          <span class="mr12">/</span>
          <span class="excellentCases">System Document</span>
        </template>
        <template v-else-if="$route.query.type == 'xuexiaozhuanlan'">
          <span class="mr12">学校专栏</span>
          <span class="mr12">/</span>
          <span class="excellentCases">School Column</span>
        </template>
      </p>
      <!-- 列表 -->
      <div class="positionRelative minHeight" v-if="pageShow == 1">
        <div
          class="pl10 boxSizing"
          v-loading="loading"
          style="position: relative; min-height: 378px"
          v-if="qtype != 'xuexiaozhuanlan'"
        >
          <template v-if="newData && newData.length > 0">
            <div
              v-for="(item, index) in newData"
              @click="getItemDetial(item.id, item)"
              class="tableDataBox"
              :key="index"
            >
              <div class="longTitle cursorClass" :title="item.title">
                <template v-if="$route.query.type == 'work_news'">
                  <span style="color: #d52127" v-if="item.type == 0"
                    >[思政动态]</span
                  >
                  <span style="color: #d52127" v-else-if="item.type == 1"
                    >[项目申报]</span
                  >
                  <span style="color: #d52127" v-else-if="item.type == 2"
                    >[评先评优]</span
                  >
                  <span style="color: #d52127" v-else-if="item.type == 3"
                    >[工作督查]</span
                  >
                  <span style="color: #d52127" v-else-if="item.type == 4"
                    >[工作通知]</span
                  >
                  <!-- <span style="color: #d52127" v-else-if="item.source == '3'"
                    >[优秀案例]</span
                  > -->
                  <span style="color: #d52127" v-else-if="item.type == 5"
                    >[优秀案例]</span
                  >

                  <span style="color: #d52127" v-else>[通知公告]</span>
                </template>
                {{ item.source == 3 ? "【精品课程】" : "" }}
                <span
                  v-if="$route.query.type == 'safety'"
                  style="color: #d52127"
                  >【课程思政】</span
                >
                <span
                  v-if="$route.query.type == 'dynamics'"
                  style="color: #d52127"
                  >【党建专栏】</span
                >
                {{ item.title }}
              </div>
              <div class="longTitle">
                {{
                  item.publishtime
                    ? item.publishtime.split(" ")[0].replace(/-/g, "\/")
                    : item.updatetime
                    ? item.updatetime.split(" ")[0].replace(/-/g, "\/")
                    : ""
                }}
              </div>

              <div class="longTitle" v-if="$route.query.type == 'excellent'">
                {{ item.createtime.split(" ")[0].replace(/-/g, "\/") }}
              </div>
            </div>
          </template>
          <!-- <template v-if="newData1 && newData1.length > 0">
            <div
              v-for="(item, index) in newData1"
              @click="getItemDetial1(item.id, item)"
              class="tableDataBox"
              :key="index"
            >
              <div class="longTitle cursorClass" :title="item.name">
                <template>
                  [评先评优]
                </template>
                {{ item.name }}
              </div>
              <div class="longTitle">
                {{
                  item.publishtime
                    ? item.publishtime.split(" ")[0].replace(/-/g, "\/")
                    : item.updatetime
                    ? item.updatetime.split(" ")[0].replace(/-/g, "\/")
                    : ""
                }}
              </div>
            </div>
          </template> -->

          <no-data
            :type="'nodata'"
            v-if="
              (!newData || newData.length == 0) &&
                (!newData1 || newData1.length == 0) &&
                !loading
            "
          ></no-data>
          <!-- <div v-if="!newData||newData.length==0" class="home-nodata">暂无数据!</div> -->
        </div>
        <div
          class=" boxSizing"
          v-loading="loading"
          style="position: relative; min-height: 378px"
          v-if="qtype == 'xuexiaozhuanlan'"
        >
          <template v-if="newData && newData.length > 0">
            <div
              v-for="(item, index) in imgData"
              @click="getItemDetial(item.id, item)"
              :key="index"
            >
              <img
                :src="item.coverUrl"
                alt=""
                class="pic"
                style=" cursor: pointer;"
              />
            </div>
          </template>
        </div>

        <div
          class="tac mt10"
          style="margin-bottom: 36px"
          v-if="qtype != 'xuexiaozhuanlan'"
        >
          <el-pagination
            prev-text="上一页"
            next-text="下一页"
            class="inlineBlock"
            backgrounnd
            layout="prev, pager, next"
            :total="totalRows"
            @current-change="handleCurrentChange"
            :current-page.sync="query.pageNo"
            :page-size="query.pageSize"
          ></el-pagination>
        </div>

        <div
          v-if="qtype == 'xuexiaozhuanlan'"
          style="width:100%; height: 480px;"
        ></div>
      </div>
      <!-- 
      详情 -->
      <div
        class="box flexRow flexStart positionRelative minHeight"
        v-loading="loading"
        v-if="pageShow == 2"
      >
        <div style="width: 100%">
          <!-- <p class="platform line32 pl16 pr16 boxSizing">
          <i class="fonticon IntegratedPlatform"></i>
          <span class="cursorClass likeBtn" @click="jumpView">返回列表</span>>新闻详情
        </p> -->
          <div class="pAll8 minHeight">
            <p class="tal newsTitle fw400">
              {{ newDetail ? newDetail.title : "" }}
            </p>
            <p
              class="f12 line32 tal fw400 tar"
              style="color: rgba(153, 153, 153, 1)"
            >
              <span class="mr8" v-if="newDetail">{{
                newDetail.remarks4 ? newDetail.remarks4 : newDetail.orgname
              }}</span>
              <!-- <span class="mr8" v-if="newDetail">{{newDetail.remarks4?newDetail.remarks4:newDetail.orgname}}</span> -->
              <span style="margin-right: 27px">{{
                newDetail ? newDetail.publishtime.slice(0, 10) : ""
              }}</span>
              <!-- <span>已阅:{{newDetail?newDetail.readnum:''}}</span> -->
            </p>
            <div
              class="tal detialContent textFont"
              v-if="newDetail && newDetail.content"
              v-html="newDetail.content"
            ></div>
            <file-edit
              :fileData="newDetail.fileList"
              type="0"
              v-if="newDetail && newDetail.fileList.length > 0"
              :read="true"
              :isBack="false"
            ></file-edit>
            <no-data :type="'nodata'" v-if="!newDetail"></no-data>
          </div>
        </div>
      </div>
      <!-- 回到顶部 -->
      <ScrollTop v-if="$route.query.id"> </ScrollTop>
      <!-- <show-file @close="close" :file="file" :showFile="showFile"></show-file> -->
    </div>
  </div>
</template>

<script>
import ScrollTop from "@/components/scroll";
import { pageNotLogin, getNOtLogin } from "@/api/login";
import { getCookie } from "@/utils/auth";
import { subTimer } from "@/utils/util";
import { getHzm } from "@/utils/util";
import fileEdit from "@/components/fileEdit";
import showFile from "@/components/showFile/index.vue";
import noData from "@/components/noData";
import {
  queryStudentBoutiqueCourses,
  getBoutiqueCourses,
  recordViews
} from "@/api/resource";
export default {
  components: {
    showFile,
    noData,
    fileEdit,
    ScrollTop
  },
  data() {
    return {
      loading: true,
      detial: {},
      newData: [],
      newData1: [],
      totalRows: 20,
      query: {
        // classid: this.$route.query.type&&$route.query.type,
        pageNo: 1,
        pageSize: 10
      },
      pageShow: 1,
      newDetail: null,
      showFile: false,
      file: {},
      qtype: "",
      newnewdata: [],
      imgData: []
    };
  },
  destroyed() {
    localStorage.removeItem("detial");
  },
  created() {
    this.begin();
    this.getInformation1();
  },
  mounted() {
    if (
      this.$route.query &&
      this.$route.query.pageShow &&
      this.$route.query.pageShow == 2
    ) {
      this.pageShow = 2;
      this.getDetial(this.$route.query.id, null);
    }
    if (this.pageShow == 1) {
      this.getInformation();
    }
  },
  methods: {
    begin() {
      this.qtype = this.$route.query.type;
      console.log(this.qtype);
    },
    // 返回首页
    goHome() {
      this.$router.push({
        path: "/home"
      });
    },
    goBackPage(type) {
      if (type === "ds") {
        const route1 = this.$router.resolve({
          path: "/dszt",
          query: {
            newsTop: "setDsTopBanner"
          }
        });
        window.open(route1.href, "_blank");
      } else {
        const route1 = this.$router.resolve({
          path: "/sqyr",
          query: {
            newsTop: "setSqTopBanner"
          }
        });
        window.open(route1.href, "_blank");
      }
    },
    // 返回列表
    jumpView() {
      this.pageShow = 1;
      this.$router.push({
        query: {
          pageShow: this.pageShow,
          type:
            this.$route.query && this.$route.query.type
              ? this.$route.query.type
              : null,
          from:
            this.$route.query && this.$route.query.from
              ? this.$route.query.from
              : null,
          gobackType:
            this.$route.query && this.$route.query.gobackType
              ? this.$route.query.gobackType
              : null
        }
      });
      this.getInformation();
      this.getInformation1();
    },
    // 新闻资讯列表
    getInformation1() {
      var query = {
        status: 3,
        top: "",
        remarks3: "xuexiaozhuanlan",
        pageNo: 1,
        pageSize: 9999
      };
      pageNotLogin(query).then(res => {
        this.imgData = res.data.rows;

        this.loadingbanner = false;
      });
    },

    getInformation() {
      var query = {
        status: 3,
        top: "",
        remarks3:
          this.$route.query.type == "excellent"
            ? "courseskey"
            : this.$route.query.type,
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize
      };

      // var params = {
      //   pageNo: this.query.pageNo,
      //   pageSize: 99999
      // };
      // queryStudentBoutiqueCourses(params).then(res => {
      //   this.totalRows = res.data.totalRows;
      //   this.newData1 = res.data.rows;
      //   console.log(this.newData1);
      // });

      this.loading = true;
      pageNotLogin(query)
        .then(res => {
          this.totalRows = res.data.totalRows;
          if (this.$route.query.type && this.$route.query.type == "work_news") {
            this.newData = res.data.rows.map(item => {
              return {
                ...item,
                type: item.relatejson ? JSON.parse(item.relatejson).type : null
              };
            });
          } else {
            this.newData = res.data.rows;
            console.log(this.newData);
          }
          this.loading = false;
          // this.newData.forEach(e => {
          //   e.day = subTimer(e.publishtime, "day");
          //   e.yM = subTimer(e.publishtime, "yM");
          // });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 分页
    handleCurrentChange(val) {
      this.query.pageNo = val;
      this.getInformation();
    },
    // 详情
    getDetial(id, item) {
      // console.log(item);
      // if (item && item.publishway && item.publishway == 1) {
      //   window.open(item.content, "_blank");
      //   return;
      // }
      this.loading = true;
      getNOtLogin({ id: id })
        .then(res => {
          this.loading = false;

          this.newDetail = res.data;
          console.log(this.newDetail.publishway);

          if (this.newDetail) {
            // this.newDetail.content = this.newDetail.content.replace(/<span\s*[^>]*>(.*?)<\/span>/ig,"$1");
            this.newDetail.content = this.newDetail.content.replace(
              / src="\//gi,
              ' src="' + this.newDetail.remarks4 + "/"
            );
          }
          if (res.data) {
            this.newDetail.publishtime = subTimer(
              this.newDetail.publishtime,
              "date"
            );
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 1健康教育 2关键课程 3精品课程
    getItemDetial(id, item) {
      console.log(item.source);
      if (item.source == 1 || item.source == 2 || item.source == undefined) {
        console.log(item.source, item, "woshinidei");
        if (item.publishway == 1) {
          window.open(item.content, "_blank");
          return;
        }
        var newWindow = window.open("", "_blank");

        this.loading = true;
        getNOtLogin({ id: id })
          .then(res => {
            this.loading = false;
            let routeData = this.$router.resolve({
              path: "/news",
              query: {
                id: id,
                pageShow: 2,
                type:
                  this.$route.query && this.$route.query.type
                    ? this.$route.query.type
                    : null,
                from:
                  this.$route.query && this.$route.query.from
                    ? this.$route.query.from
                    : null,
                gobackType:
                  this.$route.query && this.$route.query.gobackType
                    ? this.$route.query.gobackType
                    : null
              }
            });

            newWindow.location.href = window.location.origin + routeData.href;

            // window.open(routeData.href, "_blank");
            this.newDetail = res.data;
            if (this.newDetail) {
              // this.newDetail.content = this.newDetail.content.replace(/<span\s*[^>]*>(.*?)<\/span>/ig,"$1");
              this.newDetail.content = this.newDetail.content.replace(
                / src="\//gi,
                ' src="' + this.newDetail.remarks4 + "/"
              );
            }
            if (res.data) {
              this.newDetail.publishtime = subTimer(
                this.newDetail.publishtime,
                "date"
              );
            }
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        console.log("woshinidie");
        recordViews({ bcid: id }).then(res => {
          var params = {};
          params = {
            path: "/curriculum",
            query: {
              id: item.id,
              pageShow: 2
            }
          };
          let routec = this.$router.resolve(params);

          window.open(routec.href, "_blank");
        });
        // var newWindow = window.open("", "_blank");
        // this.loading = true;
        // getBoutiqueCourses({ id: id })
        //   .then(res => {
        //     this.loading = false;
        //     let routeData = this.$router.resolve({
        //       path: "/curriculum",
        //       query: {
        //         id: id,
        //         pageShow: 2
        //       }
        //     });

        //     newWindow.location.href = window.location.origin + routeData.href;
        //     this.planData = res.data;
        //     this.goDetialcurr(id);
        //   })
        //   .catch(() => {
        //     this.loading = false;
        //   });
      }
    },
    goDetialcurr(id) {
      recordViews({ bcid: id }).then(res => {});
    }
  }
};
</script>
<style scoped>
.width10 {
  margin: auto;
  width: 1000px;
}
</style>



// WEBPACK FOOTER //
// src/view/news/index.vue